(() => {
	angular.module('main').directive('anonymousHome', anonymousHome);

	anonymousHome.$inject = [];

	function anonymousHome() {
		return {
			restrict: 'E',
			replace: true,
			scope: true,
			template: require('./anonymousHome.component.html'),
			link() {}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/home/anonymousHome.component.js